import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { IClientModelAggregationType } from "../types";

export const useClientModelAggregationType = () => {
  return useQuery({
    queryKey: ["client", "model", "aggregation_type"],
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/aggregation_type`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as IClientModelAggregationType[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
